// @flow

import { rem } from 'polished';
import React from 'react';
import { useSelector } from 'react-redux';
import styled, { type StyledComponent } from 'styled-components';

import loaderTokenImage from '../../../assets/images/loader-token.gif';
import { __ } from '../../../i18n/l10n';
import { SpinePlayer } from '../../../modules/shared/components/SpinePlayer';
import type { RootState } from '../../../store/types';
import { colors, fontFamily } from '../../../styles/GlobalStyle';

type LayerLoadingRawProps = {
  className: string,
  force?: boolean,
};

const LayerLoadingRaw = ({ className, force = false }: LayerLoadingRawProps) => {
  const websocket = useSelector((state: RootState) => state.websocket);

  if (websocket.layerError) return null;

  if (force || websocket.pendingCall) {
    return (
      <div className={className}>
        <div className={'layerLoading-spine'}>
          <SpinePlayer
            skeletonName={'token'}
            fallback={(
              <img
                src={loaderTokenImage}
                alt={''}
              />
)}
            autoPlay
          />
        </div>
        <div className={'layerLoading-title'}>{__('Loading...')}</div>
        <div className={'layerLoading-text'}>{__('Your information is being processed!')}</div>
      </div>
    );
  }

  return null;
};

export const LayerLoading: StyledComponent<
  LayerLoadingRawProps,
  {},
  typeof LayerLoadingRaw
> = styled(LayerLoadingRaw)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  div {
    margin-top: 10px;
  }

  .layerLoading-spine {
    width: 300px;
    height: 300px;
  }

  .layerLoading-title {
    font-family: ${fontFamily.secondary.regular.fontFamily};
    color: ${colors.yellow};
    font-size: ${rem(30)};
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  .layerLoading-text {
    text-transform: uppercase;
    font-family: ${fontFamily.primary.black.fontFamily};
    font-weight: ${fontFamily.primary.black.fontWeight};
    font-size: ${rem(16)};
  }
`;
